import React from 'react';
import {
    Box,
    Card,
    Checkbox,
    Chip,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Tab,
    Tabs,
    Typography,
    useTheme,
} from "@mui/material";
import {
    CategoryRounded,
    PeopleAltRounded,
    PersonRounded,
} from "@mui/icons-material";
import _PersonnelCustomSelector from "./_PersonnelCustomSelector";

const _AllocationRecipientStrategy = ({
    allocationMode,
    handleModeChange,
    groups = [],
    selectedGroupId,
    setSelectedGroupId,
    selectedGroupIds,
    setSelectedGroupIds,
    searchPersonnel,
    setSearchPersonnel,
    selectedUsers,
    filteredPersonnel,
    handleSelectAllUsers,
    handleUserToggle,
    loadingPersonnel,
}) => {
    const theme = useTheme();

    // همگام‌سازی بین selectedGroupIds جدید و selectedGroupId قدیمی
    const currentGroupIds = selectedGroupIds !== undefined
        ? selectedGroupIds
        : (selectedGroupId ? [selectedGroupId] : []);

    const handleGroupSelectionChange = (newValues) => {
        if (setSelectedGroupIds) {
            setSelectedGroupIds(newValues);
        }
        if (setSelectedGroupId) {
            setSelectedGroupId(newValues.length > 0 ? newValues[0] : "");
        }
    };

    return (
        <Card
            elevation={0}
            sx={{
                mb: 3.5,
                p: 2.5,
                borderRadius: 3.5,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
            }}
        >
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1.5, color: 'text.secondary' }}>
                روش انتخاب دریافت‌کنندگان اعتبار:
            </Typography>

            <Tabs
                value={allocationMode}
                onChange={(e, val) => handleModeChange(val)}
                textColor="primary"
                indicatorColor="primary"
                sx={{
                    '& .MuiTab-root': {
                        minHeight: 46,
                        py: 1,
                        px: 3,
                        fontWeight: 800,
                        borderRadius: 2.5,
                    },
                }}
            >
                <Tab
                    value="ALL"
                    icon={<PeopleAltRounded sx={{ fontSize: 20 }} />}
                    iconPosition="start"
                    label="کل سازمان (تمامی پرسنل)"
                />
                <Tab
                    value="GROUP"
                    icon={<CategoryRounded sx={{ fontSize: 20 }} />}
                    iconPosition="start"
                    label="بر اساس گروه / دپارتمان"
                />
                <Tab
                    value="CUSTOM"
                    icon={<PersonRounded sx={{ fontSize: 20 }} />}
                    iconPosition="start"
                    label="انتخاب دستی کارمندان"
                />
            </Tabs>

            {/* Multi-Group Selector Dropdown when GROUP mode */}
            {allocationMode === "GROUP" && (
                <Box sx={{ mt: 2.5, maxWidth: 550 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="select-groups-label">انتخاب گروه‌های پرسنل (یک یا چند گروه)</InputLabel>
                        <Select
                            labelId="select-groups-label"
                            multiple
                            value={currentGroupIds}
                            onChange={(e) => handleGroupSelectionChange(e.target.value)}
                            input={<OutlinedInput label="انتخاب گروه‌های پرسنل (یک یا چند گروه)" />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((gId) => {
                                        const grp = groups.find(g => g.Id === gId);
                                        return (
                                            <Chip
                                                key={gId}
                                                label={grp ? `${grp.Name} (${grp.UserCount || 0} نفر)` : gId}
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                                sx={{ fontWeight: 700 }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            sx={{ borderRadius: 2.5 }}
                        >
                            {groups.map((group) => (
                                <MenuItem key={group.Id} value={group.Id}>
                                    <Checkbox checked={currentGroupIds.includes(group.Id)} size="small" />
                                    <Typography variant="body2">
                                        {group.Name} ({group.UserCount || 0} نفر عضو)
                                    </Typography>
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>
                            {currentGroupIds.length === 0
                                ? "لطفاً حداقل یک گروه سازمانی را انتخاب کنید."
                                : currentGroupIds.length === 1
                                    ? "اعتبار به تمامی کارمندان این گروه تخصیص داده خواهد شد."
                                    : `اعتبار به پرسنلی که حداقل در یکی از ${currentGroupIds.length} گروه انتخابی عضو باشند تعلق می‌گیرد (اجتماع گروه‌ها).`}
                        </FormHelperText>
                    </FormControl>
                </Box>
            )}

            {/* Custom Checklist when CUSTOM mode */}
            {allocationMode === "CUSTOM" && (
                <_PersonnelCustomSelector
                    searchPersonnel={searchPersonnel}
                    setSearchPersonnel={setSearchPersonnel}
                    selectedUsers={selectedUsers}
                    filteredPersonnel={filteredPersonnel}
                    handleSelectAllUsers={handleSelectAllUsers}
                    handleUserToggle={handleUserToggle}
                    loadingPersonnel={loadingPersonnel}
                />
            )}
        </Card>
    );
};

export default _AllocationRecipientStrategy;
